import periodoVigenciaServices from '@/api/financial/periodoVigenciaServices'

export default {
  loadTable({ commit }, pageConfig) {
    return periodoVigenciaServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST_PERIODO_VIGENCIA', result.data.content)
      return result
    }).catch(err => err)
  },
  insertNewPeriodoVigencia({ commit }, data) {
    return periodoVigenciaServices.insert(data).then(result => result).catch(error => error)
  },
  prepareToEditPeriodoVigencia({ commit }, data) {
    commit('PREPARE_TO_EDIT_PERIODO_VIGENCIA', data)
  },
  editPeriodoVigencia({ commit }, data) {
    return periodoVigenciaServices.update(data.id, data).then(result => result).catch(error => error)
  },
  resetPeriodoVigencia({ commit }) {
    commit('RESET_PERIODO_VIGENCIA')
  },
  delete({ commit }, id) {
    return periodoVigenciaServices.delete(id).then(result => result).catch(error => error)
  },
}
